import { GateDataRenderer } from '@features/gateCommon';
import { translateOperatingState } from '@features/gateCommon/utils/gateOperatingState';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Skeleton } from '@mui/material';
import { type FC } from 'react';
import { DisplayBox } from './DisplayBox';

interface OperatingStatusProps {
  gateId: string | null;
}

export const OperatingState: FC<OperatingStatusProps> = ({ gateId }) => {
  const { i18n } = useLingui();

  return (
    <DisplayBox label={<Trans>Estado compuerta</Trans>}>
      {gateId ? (
        <GateDataRenderer
          gateId={gateId}
          render={({ operatingState }) => {
            return translateOperatingState(operatingState, i18n);
          }}
          fallback={() => <Skeleton>Estado dummy</Skeleton>}
        />
      ) : (
        <Trans>Dispositivo no seleccionado</Trans>
      )}
    </DisplayBox>
  );
};
